import React, { Component } from 'react';
import autoimage from './autoimage.jpg';
import { Link } from 'react-router-dom';

class LandingPage extends Component {
  render() {

    const buttonStyle = {
  margin: "10px",
  fontSize: "14px",
  height: "40px",
  width: "150px",
  borderRadius: "10px",
  boxShadow: "1px 1px 0px 2px",
  cursor: "pointer"
}

  
    return(
    
      <div style={{width: '100%', margin: 'auto', textAlign: 'center'}}>
      	<img
              src={autoimage}
              alt="avatar"
              style={{height: '400px', width: '75%'}}
               />
      	<h2>Auto Repair Shops</h2>
        <p>San Francisco, CA</p>
      <Link to="/Main"><button style={buttonStyle}>Enter</button></Link>

    </div>
      )
       
	}
}

export default LandingPage;